import * as React from "react";
const SvgFiRrTourGuidePeople = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tour-guide-people_svg__a)">
      <path
        fill="#062147"
        d="M15 15c-1.654 0-3 1.346-3 3v5a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-5c0-1.654-1.346-3-3-3m1 5h-2v-2a1 1 0 0 1 2 0zM2 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M24 14v5a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-2a1 1 0 0 0-1.5-.866 1 1 0 0 1-1-1.732 3.004 3.004 0 0 1 4.5 2.599zM14.751.377A4.3 4.3 0 0 0 13 0a1 1 0 0 0-1 1v5H4c-2.206 0-4 1.794-4 4v4c0 1.474.81 2.75 2 3.444V23a1 1 0 1 0 2 0v-5h2v5a1 1 0 1 0 2 0V8h5a1 1 0 0 0 1-1V5.25l3.565-1.885c.581-.399.581-1.329 0-1.729zM6 16H4c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h2zm12.5-8.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m-6 4a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tour-guide-people_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTourGuidePeople;
